export const ACCEPTED_FILE_TYPES = Object.freeze({
  PDF: 'pdf',
  JPG: 'jpg',
  JPEG: 'jpeg',
  PNG: 'png'
} as const)

export const COOKIE = Object.freeze({
  EXPIRATION_DAYS: 365,
  MAX_AGE_SECONDS: 31536000 // 365 days in seconds
} as const)

export const COOKIE_NAME = Object.freeze({
  CONSENT: 'cookie.consent'
} as const)

export const BREAKPOINTS = Object.freeze({
  XS: 500,
  SM: 640,
  MD: 768,
  LG: 800,
  XL: 1200
} as const)

export const CUT_STRING_DEFAULT_SIZE = 36

export const BANKY_URLS = Object.freeze({
  TERMS_AND_CONDITIONS: 'https://banky.io/terms-and-conditions',
  PRIVACY_POLICY: 'https://banky.io/privacy-policy/'
} as const)

export const DATE_FORMAT = Object.freeze({
  DATE: 'DD/MM/YYYY'
} as const)

export const LANGUAGES = Object.freeze({
  EN: 'en',
  ES: 'es',
  JA: 'ja',
  HR: 'hr',
  PL: 'pl',
  PT: 'pt'
} as const)

export const COUNTRY_CODE = Object.freeze({
  SG: 'sg'
} as const)

export const NAVIGATION_ORIGIN = Object.freeze({
  TRANSACTIONS: 'transactions'
} as const)

export const FISCAL_MONTH = Object.freeze({
  M1: 'M1',
  M2: 'M2',
  M3: 'M3',
  M4: 'M4',
  M5: 'M5',
  M6: 'M6',
  M7: 'M7',
  M8: 'M8',
  M9: 'M9',
  M10: 'M10',
  M11: 'M11',
  M12: 'M12'
} as const)

export const FISCAL_QUARTER = Object.freeze({
  Q1: 'Q1',
  Q2: 'Q2',
  Q3: 'Q3',
  Q4: 'Q4'
} as const)

export const MASKED_DISPLAY = Object.freeze({
  SECRET: '********',
  PASSWORD: '••••••••'
} as const)

export const CACHE_KEYS = Object.freeze({
  IBAN_PREVIEW: 'iban-preview',
  KYB_UPLOAD_DOC: 'upload-kyb-doc',
  KYB_DELETE_DOC: 'delete-kyb-doc',
  PAYOUT_PREVIEW: 'payout-preview',
  PAYOUT_INIT: 'payout-init',
  REFUND_PREVIEW: 'refund-preview',
  REFUND_INIT: 'refund-init'
} as const)

/**
 * Width (px) at and below which list tables render as cards and a selected row opens its details inline.
 * Above it the table keeps its columns and the details sit beside it. The list pages' stylesheets use the same
 * number in their `@media (max-width: 1100px)` rules - keep them in step.
 */
export const TABLE_CARDS_MAX_WIDTH = 1100
